const Timezones = [
    '(ACDT) Australian Central Daylight Time',
    '(ACST) Australian Central Standard Time',
    '(ACT) Acre Time',
    '(ACT) Australian Central Time',
    '(ACWST) Australian Central Western Standard Time',
    '(ADT) Arabia Daylight Time',
    '(ADT) Atlantic Daylight Time',
    '(AEDT) Australian Eastern Daylight Time',
    '(AET) Australian Eastern Time  Australia',
    '(AFT) Afghanistan Time',
    '(AKDT) Alaska Standard Time',
    '(ALMT) Alma-Ata Time',
    '(AMST) Amazon Summer Time',
    '(AMT) Amazon time',
    '(AMT) Armenia Time',
    '(ANAST) Anardyr Summer Time',
    '(ANAT) Anadyr Time',
    '(AQTT) Aqtobe Time',
    '(ART) Argentina Time',
    '(AST) Arabia Standard Time',
    '(AST) Atlantic Standard Time',
    '(AT) Atlantic Time',
    '(AWDT) Australian Western Daylight Time',
    '(AWST) Australian Western Standard Time',
    '(AZOST) Azores Summer Time',
    '(AZOT) Azores Time',
    '(AZST) Azerbaijan Summer Tme',
    '(AZT) Azerbaijan Time',
    '(AoE) Anywhere on Earth',
    '(BNT) Brunei Darussalam Time',
    '(BOT) Bolivia Time',
    '(BRST) Brasilia Summer Time',
    '(BRT) Brasilia Time',
    '(BST) Brasilia Summer Time',
    '(BST) Bangladesh Standard Time',
    '(BST) Boungaiville Standard Time',
    '(BST) British Summer Time',
    '(BTT) Bhutan Time',
    '(CAST) Casey Time',
    '(CAT) Central Africa Time',
    '(CCT) Cocos Islands Time',
    '(CDT) Central Daylight Time',
    '(CEST) Central European Summer Time',
    '(CET) Central European Time',
    '(CHADT) Chattam Island Daylight Time',
    '(CHAST) Chattam Island Standard Time',
    '(CHOST) Choibalsan Summer Time',
    '(CHOT) Choibalsan Time',
    '(CHUT) Chuuk Time',
    '(CIDST) Cayman Islands Daylight Saving Time',
    '(CIST) Cayman Islands Standard Time',
    '(CKT) Cook Island Time',
    '(CLST) Chile Summer Time',
    '(CLT) Chile Standard Time',
    '(COT) Colombia Time',
    '(CST) China Standard Time',
    '(CST) Cuba Standard Time',
    '(CT) Central Time',
    '(CVT) Cape Verde Time',
    '(CXT) Christmas Islands Time',
    '(ChST) Chamoro Standard Time',
    '(DAVT) Davis Time',
    '(DDUT) Dumont-d\'Urville Time',
    '(EASST) Easter Island Summer Time',
    '(EAST) Easter Island Standard Time',
    '(EAT) Eastern African Time',
    '(ECT) Ecuador Time',
    '(EDT) Eastern Daylight Time',
    '(EEST) Eastern European Summer Time',
    '(EET) Eastern European Time',
    '(EGST) Eastern Greenland Summer Time',
    '(EGT) East Greenland Time',
    '(EST) East Standard Time',
    '(ET) Eastern Time',
    '(FET) Further-Eastern European Time',
    '(FJST) Fiji Summer Time',
    '(FJT) Fiji Time',
    '(FKST) Falkland Islands Summer Time',
    '(FKT) Falkland Island Time',
    '(FNT) Fernando de Noronha Time',
    '(GALT) Galapagos Time',
    '(GAMT) Gambier Time',
    '(GET) Georgia Standard Time',
    '(GFT) French Guiana Time',
    '(GILT) Gilbert Island Time',
    '(GMT) Greenwich Meridian Time',
    '(GST) Gulf Standard Time',
    '(GST) South Georgia Time',
    '(GYT) Guyana  Time',
    '(HDT) Hawaii-Aleutian Daylight Time',
    '(HKT) Hong Kong Time',
    '(HOVST) Hovd Summer Time',
    '(HOVT) Hovd Time',
    '(HST)  Hawaii Standard Time',
    '(ICT) Indochina Time',
    '(IDT) Israel Daylight Time',
    '(IOT) Indian Chagos Time',
    '(IRDT) Iran Daylight',
    '(IRKST) Irkutsk Summer Time',
    '(IRKT) Irkutsk Time',
    '(IRST) Iran Standard Time',
    '(IST) India Standard Time',
    '(IST) Irish Standard Time',
    '(IST) Israel Standard Time',
    '(JST) Japan Standard Time',
    '(KGT) Kyrgyzstan Time',
    '(KOST) Kosrae Time',
    '(KRAST) Krasnoyarsk Summer Time',
    '(KRAT) Krasnoyarsk Summer Time',
    '(KST) Korea Standard Time',
    '(KUYT) Kuybyshev Time',
    '(LHDT) Lord Howe Daylight Time',
    '(LHST) Lord Howe Standard Time',
    '(LINT) Line islands Time',
    '(MAGST) Magadan Summer Time',
    '(MAGT) Magadan Time',
    '(MART) Marquesas Time',
    '(MAWT) Mawson Time',
    '(MDT) Mountain Daylight Time',
    '(MHT) Marshal Islands Time',
    '(MMT) Myanmar Islands Time',
    '(MSD) Moscow Daylight Time',
    '(MSK) Moscow Standard Time',
    '(MST) Mountain Standard Time',
    '(MT) Mountain Time',
    '(MUT) Mauritius Time',
    '(MVT) Maldives Time',
    '(MYT) Malaysia Time',
    '(NCT) New Caledonia Time',
    '(NDT) Newfoundland Daylight Time',
    '(NFDT) Norfolk Daylight Time',
    '(NFT) Norfolk Time',
    '(NOVST) Novosibirsk Summer Time',
    '(NOVT)Novosibirsk Time',
    '(NPT)Nepal Time',
    '(NRT) Nauru Time',
    '(NST) Newfoundland Standard Time',
    '(NUT) Niue Time',
    '(NZDT) New Zealand Daylight Time',
    '(NZST) New Zealand Standard Time',
    '(OMSST) Omsk Standard Time',
    '(ORAT) Oral Time',
    '(PDT) Pacific Time Zone',
    '(PET) Peru Time',
    '(PETST) Kamchatka Summer',
    '(PETT) Kamchatka Time',
    '(PGT) Papua New Guinea Time',
    '(PHOT) Phoenix Island Time',
    '(PHT) Philipine Time',
    '(PKT) Pakistan Standard Time',
    '(PMDT) Pierre & Miquelon Daylight Time',
    '(PMST) Pierre & Miquelon Standard Time',
    '(PONT) Pohnpei Standard Time',
    '(PST) Pacific Standard Time',
    '(PT) Pacific Time',
    '(PWT) Palau Time',
    '(PYST) Paraguay Summer Time',
    '(PYT) Paraguay Time',
    '(PYT) Pyongyang Time',
    '(QYZT) Qyzylorda Time Zone',
    '(RET) Reunion Time',
    '(ROTT) Rothera Time',
    '(SAKT) Sakhain Time',
    '(SAMT) Samara Time',
    '(SAST) South Africa Standard Time',
    '(SBT) Solomon Islands Time',
    '(SCT) Seychelles Time',
    '(SGT) Singapore Time',
    '(SRET) Srednekolymsk Time',
    '(SRT) Suriname Time',
    '(SST) Samoa Standard Time',
    '(SYOT) Syowa Time',
    '(TAHT) Tahiti Zone',
    '(TFT) French Southern and Antartic Time',
    '(TJT) Tajikstan Time',
    '(TKT) Toklelau Time',
    '(TLT) East Timor Time',
    '(TOST) Tonga Summer Time',
    '(TOT) Tonga Time',
    '(TRT) Turkey Time',
    '(TVT) Tuvalu Time',
    '(ULAST) Ulaanbaatar Summer Time',
    '(ULAT) Ulaanbaatar Time',
    '(UTC) Coordinaated Universal Time',
    '(UYST) Uruguay Summer Time',
    '(UYT) Uruguay Time',
    '(UZT) Uzbekistan Time',
    '(VET) Venezuelan Standard Time',
    '(VLAST) Vladivostok Summer Time',
    '(VLAT) Vladivostok Time',
    '(VOST) Vostok Time',
    '(VUT) Vanuatu Time',
    '(WAKT) Wake Time',
    '(WARST) Western Argentina Summer Time',
    '(WAST) West African Summer Time',
    '(WAT) West African Time',
    '(WEST) Western European Summer Time',
    '(WET) Western European Time',
    '(WFT) Wallis and Futuna Time',
    '(WGST) Western Greenland Summer Time',
    '(WGT) West Greenland Time',
    '(WIB) Western Indonesian Time',
    '(WIT) Eastern Indonesian Time',
    '(WITA) Central Indonesian Time',
    '(WST) West Samoa Time',
    '(WT) Western Sahara Standard Time',
    '(YAKST) Yakutsk Summer Time',
    '(YAKT) Yakutsk Time',
    '(YAPT) Yap Time',
    '(YEKST) Yekaterinburg Summer Time',
    '(YEKT) Yekaterinburg Time'
]

export default Timezones